import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'duration'
})

export class DurationPipe implements PipeTransform {

    transform(start: Date | string, end: Date | string): string {

        let result: string = "";

        if (start && end) {

            const startDate = new Date(start);
            const endDate = new Date(end);
            let diff = Math.floor((endDate.getTime() - startDate.getTime()) / 1000); // in seconds

            if (diff >= 0) {

                const days = Math.floor(diff / 86400);
                diff %= 86400;
                const hours = Math.floor(diff / 3600);
                diff %= 3600;
                const minutes = Math.floor(diff / 60);
                const seconds = diff % 60;

                const parts = [];

                if (days) {

                    parts.push(`${days} day${days > 1 ? "s" : ""}`);
                }

                if (hours) {

                    parts.push(`${hours} hour${hours > 1 ? "s" : ""}`);
                }

                if (minutes) {

                    parts.push(`${minutes} minute${minutes > 1 ? "s" : ""}`);
                }

                if (seconds || parts.length === 0) {

                    parts.push(`${seconds} second${seconds > 1 ? "s" : ""}`);
                }

                result = parts.join(" ");
            }
        }

        return result;
    }
}

